import {
	//GET_GENERAL_SESSION_COOKIE,
	SET_GENERAL_APP_COOKIE,
	SET_FORM_VALIDATION,
	SET_PROFILE_INFO,
	SET_LOGIN_STATE,
	RESET_DEFAULT_STATE,
	FORM_IS_INVALID,
	GET_INVITATION_CODES,
} from '~/data/constants/authentication-constants';

import { GET_MY_TEAM, UPDATE_TEAM_NAME, UPDATE_EMAIL } from '~/data/constants/profile-constants';

const initialState = {
	valid: undefined,
	hasCookie: false,
	stravaLoginURL: null,
	isLoggedIn: false,
	profile: {},
	myTeam: {},
	invitationCodes: [],
};

function authentication(state = initialState, action) {
	switch (action.type) {
		case SET_GENERAL_APP_COOKIE:
			return {
				...state,
				valid: action.valid,
				hasCookie: action.hasCookie,
				stravaLoginURL: action.stravaLoginURL,
			};
		case SET_FORM_VALIDATION:
			return {
				...state,
				valid: action.valid,
			};
		case SET_LOGIN_STATE:
			return {
				...state,
				hasCookie: action.hasCookie,
				isLoggedIn: action.isLoggedIn,
				profile: action.profile,
			};

		case SET_PROFILE_INFO:
			return {
				...state,
				isLoggedIn: action.isLoggedIn,
				profile: action.profile,
			};

		case RESET_DEFAULT_STATE:
			return {
				valid: undefined,
				hasCookie: false,
				stravaLoginURL: null,
				isLoggedIn: false,
				profile: {},
			};

		case FORM_IS_INVALID:
			return {
				...state,
				valid: action.valid,
			};

		case GET_INVITATION_CODES:
			return {
				...state,
				invitationCodes: action.invitationCodes,
			};

		case GET_MY_TEAM:
			return {
				...state,
				myTeam: action.myTeam,
			};

		case UPDATE_TEAM_NAME:
			return {
				...state,
				myTeam: action.myTeam,
			};

		case UPDATE_EMAIL:
			return {
				...state,
				profile: { ...state.profile, contactEmail: action.contactEmail },
			};
		default:
			return state;
	}
}

export default authentication;



// WEBPACK FOOTER //
// ./src/redux/reducers/authentication-reducer.jsx